/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PatchContractTypeV1Dto = {
  /**
   * Contract category for contracts
   */
  category?: PatchContractTypeV1Dto.category;
  /**
   * The name of the contract-type.
   */
  name?: string;
  /**
   * The order number of the contract-type.
   */
  order?: number;
  /**
   * The current version of the contract.
   */
  readonly version: number;
};
export namespace PatchContractTypeV1Dto {
  /**
   * Contract category for contracts
   */
  export enum category {
    SERVICE = 'Service',
  }
}
